// Passwort sichtbar machen
//
// Ergänzt Passwortfelder um eine Schaltfläche mit Auge-Symbol, die zwischen
// verdeckter und sichtbarer Eingabe umschaltet. Aktiviert wird das über das
// Attribut data-password-toggle am Eingabefeld. Ohne JavaScript bleibt das Feld
// ein normales Passwortfeld – die Schaltfläche wird erst hier erzeugt.

const LABEL_SHOW = 'Passwort anzeigen'
const LABEL_HIDE = 'Passwort verbergen'

function eyeIcon (crossedOut) {
  const slash = crossedOut ? '<path d="M4 20 20 4"/>' : ''

  return '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M2 12s3.6-6.5 10-6.5 10 6.5 10 6.5-3.6 6.5-10 6.5S2 12 2 12z"/>' +
    '<circle cx="12" cy="12" r="3"/>' +
    slash +
    '</svg>'
}

function enablePasswordToggle (input) {
  const wrapper = input.closest('.form-floating') || input.parentElement

  if (!wrapper || wrapper.querySelector('.uo-password-toggle')) return

  const button = document.createElement('button')
  button.type = 'button'
  button.className = 'uo-password-toggle'
  button.innerHTML = eyeIcon(false)
  button.setAttribute('aria-pressed', 'false')
  button.setAttribute('aria-label', LABEL_SHOW)
  button.setAttribute('title', LABEL_SHOW)

  if (input.id) {
    button.setAttribute('aria-controls', input.id)
  }

  button.addEventListener('click', function () {
    const sichtbarMachen = input.type === 'password'
    const position = input.selectionStart

    input.type = sichtbarMachen ? 'text' : 'password'

    button.innerHTML = eyeIcon(sichtbarMachen)
    button.setAttribute('aria-pressed', sichtbarMachen ? 'true' : 'false')
    button.setAttribute('aria-label', sichtbarMachen ? LABEL_HIDE : LABEL_SHOW)
    button.setAttribute('title', sichtbarMachen ? LABEL_HIDE : LABEL_SHOW)

    // Fokus und Schreibposition erhalten, damit die Eingabe nicht abreißt
    input.focus()

    if (position !== null && typeof position !== 'undefined') {
      try {
        input.setSelectionRange(position, position)
      } catch (e) {
        // Einzelne Browser erlauben setSelectionRange bei type="password" nicht
      }
    }
  })

  wrapper.appendChild(button)
  // Erst mit vorhandener Schaltfläche wird Platz im Feld freigehalten
  wrapper.classList.add('has-password-toggle')
}

document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('input[type="password"][data-password-toggle]')
    .forEach(enablePasswordToggle)
})
